import { cloneElement, useRef } from "react";
import BootstrapOverlayTrigger from "react-bootstrap/OverlayTrigger";
import {
  acquireBodyOverflowLock,
  suppressBodyOverflowBriefly,
} from "../../utils/helpers/helper";

const lockFromEvent = (handler) => (event) => {
  suppressBodyOverflowBriefly();
  if (typeof handler === "function") handler(event);
};

const withOverflowLock = (props = {}) => ({
  ...props,
  onMouseOverCapture: lockFromEvent(props.onMouseOverCapture),
  onMouseOutCapture: lockFromEvent(props.onMouseOutCapture),
  onFocusCapture: lockFromEvent(props.onFocusCapture),
  onBlurCapture: lockFromEvent(props.onBlurCapture),
});

const OverlayTrigger = ({
  children,
  popperConfig,
  onToggle,
  onExited,
  ...props
}) => {
  const releaseRef = useRef(null);
  const generationRef = useRef(0);

  const hold = () => {
    generationRef.current += 1;
    if (!releaseRef.current) {
      releaseRef.current = acquireBodyOverflowLock();
    }
  };

  const drop = (generation) => {
    if (generation !== generationRef.current) return;
    releaseRef.current?.();
    releaseRef.current = null;
  };

  const handleToggle = (nextShow) => {
    if (nextShow) {
      hold();
    } else {
      const generation = generationRef.current;
      window.setTimeout(() => drop(generation), 350);
    }
    onToggle?.(nextShow);
  };

  const handleExited = (...args) => {
    drop(generationRef.current);
    onExited?.(...args);
  };

  const child =
    typeof children === "function"
      ? (triggerProps) => children(withOverflowLock(triggerProps))
      : cloneElement(children, withOverflowLock(children.props));

  return (
    <BootstrapOverlayTrigger
      {...props}
      popperConfig={{
        strategy: "fixed",
        ...popperConfig,
      }}
      onToggle={handleToggle}
      onExited={handleExited}
    >
      {child}
    </BootstrapOverlayTrigger>
  );
};

export default OverlayTrigger;
